<template>
  <div class="SubmitSuccess" :style="{'width':width,'height':height}">
    <van-nav-bar
      title="杰宝运维平台工单报修申请"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content">
      <img src="../../assets/submitSuccess.png" class="img" alt="">
      <h2>提交成功</h2>
      <div class="text">我们已收到您的反馈,感谢填写</div>
      <van-button type="primary" class="btn" @click="onClickLeft">返回</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubmitSuccess',
  components: {},
  data() {
    return {
      type: '',
      width: '0',
      height: '0'
    }
  },
  created() {
    this.getBrowserInterfaceSize()
    if (this.$route.query.type === 'success') {
      this.type = 'success'
    } else {
      this.$router.push({ name: 'AppRepair' })
      this.type = 'filed'
    }
  },
  methods: {
    onClickLeft() {
      this.$router.push({ name: 'AppRepair' })
    },
    getBrowserInterfaceSize() {
      var pageWidth = window.innerWidth
      var pageHeight = window.innerHeight
      if (typeof pageWidth !== 'number') {
        // 在标准模式下面
        if (document.compatMode === 'CSS1Compat') {
          pageWidth = document.documentElement.clientWidth
          pageHeight = document.documentElement.clientHeight
        } else {
          pageWidth = document.body.clientWidth
          pageHeight = window.body.clientHeight
        }
      }
      this.width = pageWidth + 'px'
      this.height = pageHeight + 'px'
    }
  }
}
</script>

<style scoped lang='scss'>
.SubmitSuccess {
  background-color: #f5f5f5;
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 1.25rem;
    .img {
      width: 12.5rem;
      height: 12.5rem;
    }
    .text{
      margin: .625rem 0 .9375rem;
    }
    .btn{
      width: 100%;
      border-radius: .625rem;
    }
  }
}
</style>
